import { PosRiskAction } from './posrisk.action';
import { InitializerAction } from '../initializer/initiliazer.action';
import { CustodyClientOrder } from '../../models/custody/custody-client-order.model';

export class PosRiskState {
    public error: any;
    public pending: boolean;
    public stresses: any;
    public custodies: CustodyClientOrder[];
    public riskModel: number;
    public defaultStress: any;
    public strategyStress: any;
    public dayTradeStress: any;
    public stressesPendings: string[];
    public pendingStressRequests: string[];
    public permission: {
        data: any;
        pending: boolean;
        error: Error;
    };
}

export const initialGenericState: PosRiskState = {
    error: null,
    pending: false,
    stresses: {},
    custodies: [],
    riskModel: null,
    defaultStress: {},
    strategyStress: {},
    dayTradeStress: {},
    stressesPendings: [],
    pendingStressRequests: [],
     permission: {
        data: null,
        pending: false,
        error: null,
    },
};

export function PosRiskReducer(state: PosRiskState = initialGenericState, action: any){

    switch (action.type) {

        case PosRiskAction.gettingStress:
            return {
                ...state,
                ...{
                    pending: true,
                    pendingStressRequests: [
                        ...state.pendingStressRequests,
                        action.payload.hash
                    ],
                    error: null
                }
            };

        case PosRiskAction.getStrategyStressSuccess:
             return {
                 ...state,
                 ...{
                    pending: false,
                    error: null,
                    strategyStress: {
                        ...state.strategyStress,
                        ...{
                            [action.payload.code]: action.payload.data
                        }
                    },
                    pendingStressRequests: state.pendingStressRequests
                    .filter((hash) => hash != action.payload.hash)
                }
            };

        case PosRiskAction.getDayTradeStressSuccess:
            return {
                ...state,
                ...{
                   pending: false,
                   error: null,
                   dayTradeStress: {
                       ...state.dayTradeStress,
                       ...{
                           [action.payload.code]: action.payload.data
                        }
                    },
                   pendingStressRequests: state.pendingStressRequests
                   .filter((hash) => hash != action.payload.hash)
               }
           };

        case PosRiskAction.getDefaultStressSuccess:
           return { ...state, ...{
                  pending: false,
                  error: null,
                  defaultStress: {
                      ...state.defaultStress,
                      ...{
                          [action.payload.code]: action.payload.data
                        }
                    },
                  pendingStressRequests: state.pendingStressRequests
                  .filter((hash) => hash != action.payload.hash)
              }
          };

        case PosRiskAction.getStressError:
            return {
                ...state,
                ...{
                    pending: state.pendingStressRequests
                    .filter((hash) => hash != action.payload.hash).length === 0,
                    error: action.payload.error,
                    pendingStressRequests: state.pendingStressRequests
                    .filter((hash) => hash != action.payload.hash)
                }
            };


        case PosRiskAction.getClientCustodies:
            return {
                ...state,
                ...{
                    pending: true,
                    error: null
                }
            };

        case PosRiskAction.getClientCustodiesSuccess:
            return {
                ...state,
                ...{
                    pending: false,
                    custodies: action.payload,
                    error: null
                }
            };

        case PosRiskAction.getClientCustodiesError:
            return {
                ...state,
                ...{
                    pending: false,
                    error: action.payload
                }
            };
        case InitializerAction.resetUserRelatedData:
            return {
                ...state, ...
                {
                    custodies: initialGenericState.custodies
                }
            };

        case PosRiskAction.getClientRiskModel:
            return {
                ...{
                    riskModel: state.riskModel
                },
                ...{
                    pending: false,
                    error: false
                }
            };

        case PosRiskAction.setClientRiskModel:
            return {
                ...{
                    riskModel: state.riskModel
                },
                ...{
                    pending: false,
                    error: false
                }
            };

        case PosRiskAction.setAccountPermission:
            return {
                ...state,
                permission: {
                    ...state.permission,
                    pedding: true,
                    error: null,
                },
            };

        case PosRiskAction.setAccountPermissionError:
            return {
                ...state,
                permission: {
                    ...state.permission,
                    pedding: false,
                    error: action.payload,
                },
            };

        case PosRiskAction.setAccountPermissionSuccess:
            return {
                ...state,
                permission: {
                    pedding: false,
                    data: action.payload,
                    error: null,
                },
            };

        default:
            return state;
    }
};
